import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import { router } from './router';
import { useSettingsStore } from './stores/settingsStore';
import { useWatchlistStore } from './stores/watchlistStore';
import './style.css';

async function bootstrap(): Promise<void> {
  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);
  app.use(router);

  // Eager-load critical stores so initial render has data.
  const settings = useSettingsStore();
  const watchlist = useWatchlistStore();
  await Promise.all([settings.load(), watchlist.load()]);

  app.mount('#app');

  // SW navigation messages (from notificationclick)
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.addEventListener('message', (event) => {
      const data = event.data as { type?: string; url?: string } | undefined;
      if (data?.type === 'NAVIGATE' && data.url) {
        try {
          const url = new URL(data.url, window.location.origin);
          if (url.origin === window.location.origin) {
            // Internal — use router hash
            const hash = url.hash || '#/';
            window.location.hash = hash;
          } else {
            window.open(data.url, '_blank', 'noopener');
          }
        } catch {
          /* ignore */
        }
      }
    });
  }
}

bootstrap().catch((err) => {
  // eslint-disable-next-line no-console
  console.error('Bootstrap failed', err);
});
